import React from "react";
import { Box, Skeleton } from "@mui/material";

const SkeletonThumbnailLoader = () => {
  return (
    <Box
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "0.75rem",
        flexShrink: 0,
        padding: "1rem",
        background: "lightgray",
        borderRadius: "0.5rem",
      }}
    >
      <Skeleton variant="rectangular" width={200} height={20} />
      <Skeleton variant="rounded" width="100%" height={210} />
      <Skeleton variant="rectangular" width={150} height={20} />
      <Skeleton variant="text" width="80%" />
    </Box>
  );
};

export default SkeletonThumbnailLoader;
